import styled, { keyframes, css } from 'styled-components';

const glowGrow = keyframes`
  0% {
    opacity: 0;
    transform: scale(1);
  }
  80% {
    opacity: 0.8;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
`;

export const Container = styled.div`
  position: relative;
`;

type NotificationDotProps = {
  $show: boolean;
};

export const NotificationDot = styled.div<NotificationDotProps>`
  ${props =>
    props.$show
      ? css`
          position: absolute;
          top: 8px;
          left: 8px;
          height: 12px;
          width: 12px;
          border-radius: 50%;
          border: 2px solid white;
          background: #d9464d;
          &:after {
            position: absolute;
            content: '';
            height: 100%;
            width: 100%;
            top: 0%;
            left: 0%;
            border-radius: 50%;
            box-shadow: 0 0 3px #d9464d;
            animation: ${glowGrow} 1.2s ease-out infinite;
          }
          &:after {
            animation-delay: 0.2s;
          }
        `
      : css`
          display: none;
        `};
`;
